"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const store_1 = __importDefault(require("../../store"));
const receiveP2PMessage_1 = __importDefault(require("../../actions/chats/receiveP2PMessage"));
const sendMessage_1 = require("../../actions/chats/sendMessage");
const userTyping_1 = require("../../actions/chats/userTyping");
const RemoteUserTypingHandler_1 = __importDefault(require("../../domain/RemoteUserTypingHandler"));
const markMessagesAsRead_1 = require("../../actions/chats/markMessagesAsRead");
const markRemoteUserOnline_1 = __importDefault(require("../../actions/users/markRemoteUserOnline"));
class RtcMessageReceiver {
    constructor() {
        this.handleMessage = (from, message) => {
            store_1.default.dispatch(markRemoteUserOnline_1.default(from));
            const p2pMessageRaw = JSON.parse(message);
            switch (p2pMessageRaw.kind) {
                case markMessagesAsRead_1.MARK_MESSAGES_AS_READ_REMOTELY: {
                    const { messageIds } = p2pMessageRaw;
                    store_1.default.dispatch(markMessagesAsRead_1.markMessagesAsReadRemotely(from, messageIds));
                    break;
                }
                case markMessagesAsRead_1.MARK_MESSAGES_AS_READ_BY_CLIENT_ID_REMOTELY: {
                    const { clientMessageIds } = p2pMessageRaw;
                    store_1.default.dispatch(markMessagesAsRead_1.markMessagesAsReadByClientIdRemotely(from, clientMessageIds));
                    break;
                }
                case sendMessage_1.SEND_MESSAGE_REQUESTED: {
                    const chatId = BigInt(p2pMessageRaw.chatId);
                    const p2pMessage = {
                        kind: "p2p",
                        clientMessageId: p2pMessageRaw.clientMessageId,
                        date: new Date(),
                        sender: from,
                        content: p2pMessageRaw.content,
                        repliesTo: p2pMessageRaw.repliesTo
                    };
                    RemoteUserTypingHandler_1.default.markTypingStopped(chatId, from);
                    store_1.default.dispatch(receiveP2PMessage_1.default(chatId, p2pMessage));
                    break;
                }
                case userTyping_1.REMOTE_USER_TYPING: {
                    const chatId = BigInt(p2pMessageRaw.chatId);
                    RemoteUserTypingHandler_1.default.markTyping(chatId, from);
                    break;
                }
                case userTyping_1.REMOTE_USER_STOPPED_TYPING: {
                    const chatId = BigInt(p2pMessageRaw.chatId);
                    RemoteUserTypingHandler_1.default.markTypingStopped(chatId, from);
                    break;
                }
            }
        };
    }
}
const receiver = new RtcMessageReceiver();
exports.default = receiver;
